// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;Let them praise your name, which is great and awesome;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;the Lord our God is holy.<br> </p> </div></div>";
// Exports
module.exports = code;